export default "__VITE_ASSET__a7ec1f36__"